import React from 'react';
import { Button, Dialog } from 'ui';
import useDialogSelectPlatform, { PlatformOption } from './useDialogSelectPlatform';

type PlatformOptionButtonProps = {
  onSelectPlatform: (option: PlatformOption) => void;
  option: PlatformOption;
};

/**
 * Botón de una plataforma dentro del listado del diálogo.
 * Existe como componente propio para poder enlazar la opción sin lógica inline en el JSX del diálogo.
 */
function PlatformOptionButton({ onSelectPlatform, option }: PlatformOptionButtonProps): JSX.Element {
  function handleClick(): void {
    onSelectPlatform(option);
  }

  return (
    <Button
      className="dialog-select-platform__button"
      isFullWidth
      onClick={handleClick}
      rightIcon="chevron-right"
      size="sm"
      variant="primary-outline"
    >
      {/* El logo es decorativo: el nombre accesible del botón ya lo aporta el `<span>` */}
      {option.logo && <img alt="" className="dialog-select-platform__logo" src={option.logo} />}
      <span className="dialog-select-platform__name">{option.name}</span>
    </Button>
  );
}

/**
 * DialogSelectPlatform - Diálogo bloqueante que obliga a elegir un proyecto ByME
 * y redirige a la plataforma correspondiente.
 */
function DialogSelectPlatform(): JSX.Element {
  const { isOpen, onSelectPlatform, platformOptions, t } = useDialogSelectPlatform();

  return (
    // Lo que hace el diálogo bloqueante es la ausencia de `onClose`: ni el ESC ni el backdrop lo cierran.
    // `isCloseButtonHidden` se mantiene como declaración explícita de la intención.
    <Dialog className="dialog-select-platform" isCloseButtonHidden isOpen={isOpen} title={t('login:Choose a project to get started')}>
      <ul className="dialog-select-platform__list">
        {platformOptions.map((option) => (
          <li className="dialog-select-platform__item" key={option.id}>
            <PlatformOptionButton onSelectPlatform={onSelectPlatform} option={option} />
          </li>
        ))}
      </ul>
    </Dialog>
  );
}

export default DialogSelectPlatform;
